import { Request } from "@henrotaym/api-client";
import { JsonCredential } from "@henrotaym/api-client";
import setup from "@spa/setup";

/** Representing a credential setting up requests for authenticated user. */
class AppClientCredential extends JsonCredential
{
     /** @type {?import("../auth/types").AuthenticatedUserResponseAppInterface} */
     app;

     /**
      * Constructin credentials based on given key (current app key if none given).
      * @param {string} app_key
      */
     constructor(app_key = setup.current_app_key) {
         super();
         this.app = setup.apps.find(app => app.key === app_key);
         this.account = this.app?.accounts.at(0);
     }
 
     /**
      * Preparing given request.
      * @param {Request<any>} request
      * @returns {void}
      */
     prepare(request) {
         super.prepare(request);
 
         if (!this.app) return;
         
         request.setBaseUrl(this.app.direct_url);
         request.addHeaders({
             ["X-TRUSTUP-AUTHORIZATION"]: `${setup.token.token_type} ${setup.token.access_token}`,
         });
 
         if (!this.account) return;
 
         request.addHeaders({
             ["X-ACCOUNT-UUID"]: this.account.uuid,
         })
     }
}

export default AppClientCredential;
